import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { NotFoundComponent } from './components/notFound/notFound.component';
import { HomeComponent } from './components/home/home.component';
import { AnouncementListComponent } from './components/anouncement-list/anouncement-list.component';
import { AnouncementDetailComponent } from './components/anouncement-detail/anouncement-detail.component';
import { AnouncementComponent } from './components/home/anouncement/anouncement.component';
import { MessageListComponent } from './components/message-list/message-list.component';
import { FindPsdComponent } from './components/find-psd/find-psd.component';

import { AnoucementDetailResolver } from './components/anouncement-detail/ano-detail.resolver';
import { AuthService } from '../core/services/auth.service';
import { UserCenterComponent } from './components/userCenter/userCenter/userCenter.component';
import { PasswordComponent } from './components/userCenter/password/password.component';
import { UserInfoComponent } from './components/userCenter/userInfo/userInfo.component';

const routes: Routes = [
    {
        path: 'home', component: HomeComponent,
        data: { title: 'home.common.title-home' },
        canActivate: [AuthService]
    },
    {
        path: 'login', component: LoginComponent,
        data: { title: 'home.common.title-login' }
    },
    {
        path: 'register', component: RegisterComponent,
        data: { title: 'home.common.title-register' }
    },
    {
        path: 'user', component: UserCenterComponent,
        data: { title: 'home.user.user-center' }
    },
    {
        path: 'user/password', component: PasswordComponent,
        data: { title: 'home.user.modify-password' }
    },
    {
        path: 'user/info', component: UserInfoComponent,
        data: { title: 'home.user.modify-info' }
    },
    {
        path: 'anounce/list', component: AnouncementListComponent,
        data: { title: 'home.common.title-anounce' },
        canActivate: [AuthService]
    },
    {
        path: 'anounce/detail/:id', component: AnouncementDetailComponent,
        data: { title: 'home.common.title-anounce-detail' },
        resolve: { detail: AnoucementDetailResolver },
        canActivate: [AuthService]
    },
    {
        path: 'message', component: MessageListComponent,
        data: { title: 'home.common.title-message' },
        canActivate: [AuthService]
    },
    {
        path: 'findPsd', component: FindPsdComponent,
        data: { title: 'home.common.find-psd' }
    },
    {
        path: 'notfound', component: NotFoundComponent,
        data: { title: '404' }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class HomeRoutingModule { }



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/home-routing.module.ts